import {Component} from 'vue-property-decorator';
import {MD} from '../global_vars';
import {animateText, smoothScrollTo} from '../utils/miscellanea';
import GFade from '../components/gfade/GFade';
import * as basicLightbox from 'basiclightbox';
import {clearAllBodyScrollLocks, disableBodyScroll} from 'body-scroll-lock';
import Event from '../utils/Event';
import {mixins} from 'vue-class-component';
import Accordion from '../components/accordion/Accordion';
import Slider3 from '../components/slider3/Slider3';
import {delay} from '../utils/async';
import Gallery2 from "../components/gallery2/Gallery2";
import FormRequestKP from "../components/form/FormRequestKP";
import 'vue-js-modal';
import BranchForm from "../mixins/BranchForm";
import FormRequestBranch from "../components/form/FormRequestBranch";
import FormRequestPres from "../components/form/FormRequestPres";
// import anime from 'animejs/lib/anime.es.js';
// @ts-ignore

@Component({
  components: {
    GFade, Accordion, Slider3, Gallery2
  }
})
export default class VMBranch extends mixins(BranchForm) {
  loadVideo = false;
  si2 = false;
  sliderOptions = {
    autoplay: true,
    loop: true,
    autoplayButtonOutput: false,
    responsive: {
      768: {
        items: 2,
        gutter: 20,
      },
      1024: {
        items: 3,
        gutter: 20,
      },
    }
  };

  async mounted() {
    Event.listen('close-agreement', () => {
      this.lbInstance?.close();
    });

    if (!MD.mobile()) {
      animateText(<HTMLElement>this.$refs.title).then();
    }

    Event.listen('open-form-request-branch', () => {
      this.openBranchForm();
    });

    await delay(500);
  }

  playVideo() {
    // if (this.si2 == false) {
    //   this.si2 = true;
    //   return;
    // }

    this.loadVideo = true;
  }

  scrollToBottomForm() {
    smoothScrollTo('.branch__form-l');
  }

  nextReviewSlide() {
    Event.fire('next-slide');
  }

  prevReviewSlide() {
    Event.fire('prev-slide');
  }

  openDesc(key: string) {

    this.lbInstance = basicLightbox.create(
      document.querySelector(`#service1-desc-${key}`)!.innerHTML,
      {
        className: 'lb-th1',
        onShow: (_) => {
          disableBodyScroll(document.querySelector('.lb')!!);
          return true;
        },
        onClose: (_) => {
          clearAllBodyScrollLocks();
          return true;
        }
      }
    );

    this.lbInstance.show();
  }

  openPresForm() {
    this.$modal.show(FormRequestPres,
      {},
      {
        height: 'auto', width: '100%', maxWidth: 1152, adaptive: true, scrollable: true,
        transition: 'nice-modal-fade',
      },
    );
  }

  openBranchForm() {
    this.$modal.show(FormRequestBranch,
      {},
      {
        height: 'auto', width: '100%', maxWidth: 1152, adaptive: true, scrollable: true,
        transition: 'nice-modal-fade',
      },
    );
  }
}
